module.exports = __webpack_public_path__ + "../resources/img/logo.3a7a019c.svg";